


































































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cleanedFileName } from '@/core/utils/utils';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import HMVueEditor from '@/web/components/common/HMVueEditor.vue';

export default Vue.extend({
  components: {
    ValidationObserver,
    TopNav,
    NavItem,
    HMVueEditor,
  },
  mixins: [DirtyMixin],
  data() {
    return {
      form: null,
    };
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
    noteId() {
      return this.$route.params.id;
    },
    customerNotesQuery() {
      return {
        customerId: this.getUserId,
        q: '',
      };
    },
  },
  methods: {
    async saveNote() {
      const noteData = {
        ...this.form,
        attachments: this.form.attachments?.map(attachment => attachment.id),
      };
      try {
        await this.$store.dispatch('sale/updateCustomerNote', {
          customerId: this.$route.params.customerId,
          noteData,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.TEXT.NOTE_SAVED_SUCCESFULLY'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: this.$t('CUSTOMERS.TEXT.NOTE_SAVED_ERROR'),
        });
      }
      this.clearDirty();
      this.$router.go(-1);
    },
    addFile(file) {
      this.form.attachments.push(file);
    },
    removeFile(fileIndex) {
      this.form.attachments.splice(fileIndex, 1);
    },
    downloadAttachment(file) {
      return window.open(file.storage_url, '_blank');
    },
    cleanedFileName,
  },
  async created() {
    this.form = await this.$store.dispatch('sale/getCustomerNote', {
      customerId: this.customerId,
      noteId: this.noteId,
    });
  },
  watch: {
    form: {
      handler(newForm, oldForm) {
        if (oldForm) {
          this.setDirty();
        }
      },
      deep: true,
    },
  },
});
